import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ data = [], labels = [], backgroundColors = [] }) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: 'Total',
                data: data,
                backgroundColor: backgroundColors,
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
    };


    return (
        <div >
            <Pie data={chartData} options={options} />
        </div>
    );
};

export default PieChart;